/* ACHILLES - category image tiles in the menu
   Mobile: a scrollable row inside each gender group, under its "New Arrivals" entry.
   Desktop: the same tiles as a row across the bottom of that side's megamenu.
   The stylesheet also sets the drop entries (Back to City / New Arrivals, both sides)
   in uppercase bold, in the manner of DeFacto's "BACK TO COLLEGE".

   Three things the mobile drawer does that this has to work around:
   1. Every group ships COLLAPSED, so the tiles would be hidden behind a tap. The women's
      tiles are TWO levels deep (WOMAN > Back to City > New Arrivals), so opening only the
      gender group is not enough - the whole ancestor chain of collapsibles has to be opened,
      outermost first, with a beat between each so the theme's animation keeps up.
   2. The theme re-collapses everything during its own init, so this waits for the drawer to
      actually open before touching anything.
   3. Opening the drawer leaves the tile row scrolled a few px, which clips the first tile, so
      the row is reset to scrollLeft 0 afterwards.
   Set AUTO_OPEN = false to leave the mobile menu exactly as the theme ships it.

   Labels are deliberately SHORT - anything past ~12 characters truncates in a 104px tile.
   CHECK THE PICTURE MATCHES THE CATEGORY: the men's editorial files are named by scene, not by
   style (men_edit_slipon_bw is a black lace-up SNEAKER, not a loafer).
   "pos" sets object-position for a tile - use it when the shoe sits low in a full-length shot.
   Pairs with achilles-menu-tiles.css - bump CSS_VERSION after editing it. */
(function () {
  'use strict';

  var CSS_VERSION = '7';
  var AUTO_OPEN = true;
  var F = 'https://cdn.shopify.com/s/files/1/0560/3210/0442/files/';
  var C = 'https://cdn.shopify.com/s/files/1/0560/3210/0442/collections/';

  var SETS = [
    {
      under: 'btc-new-arrivals',
      side: 'women',
      items: [
        { label: 'Heels',    url: '/collections/btc-heels',    img: C + 'btc_lookbook_08.png?v=1788899750' },
        { label: 'Flats',    url: '/collections/btc-flats',    img: C + 'btc_lookbook_10.png?v=1788899754' },
        { label: 'Sandals',  url: '/collections/btc-sandals',  img: C + 'btc_lookbook_14.png?v=1788899755' },
        { label: 'The Drop', url: '/collections/back-to-city', img: F + 'btc_lookbook_04.png?v=1788896144' }
      ]
    },
    {
      under: 'men-new-arrivals-2026',
      side: 'men',
      items: [
        { label: 'EVA',      url: '/collections/comfort-eva-collection', img: C + 'men_edit_checkered_jump.png?v=1788991443' },
        { label: 'Lace-Up',  url: '/collections/lace-ups',               img: C + 'men_edit_cairo_bw.png?v=1788991445' },
        // Mohamed's picks: the standing shot wears chunky-soled loafers, the gallery shot sneakers
        { label: 'Loafers',  url: '/collections/men-loafers-2026',    img: F + 'men_edit_studio_standing.png?v=1788956426', pos: 'center 65%' },
        { label: 'Boat',     url: '/collections/men-boat-shoes-2026', img: C + 'mbs2sn-2.jpg?v=1786539504' },
        { label: 'Sneakers', url: '/collections/men-sneakers-2026',   img: F + 'men_edit_gallery_dog.png?v=1788956426', pos: 'center 65%' }
      ]
    }
  ];

  var me = document.currentScript && document.currentScript.src;
  if (me && !document.querySelector('link[href*="achilles-menu-tiles.css"]')) {
    var href = me.split('?')[0].replace('achilles-menu-tiles.js', 'achilles-menu-tiles.css');
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href + '?v=' + CSS_VERSION;
    document.head.appendChild(l);
  }

  function side() {
    var p = (location.pathname + location.search).toLowerCase();
    var menish = ['/pages/men', '/collections/men-', '/collections/lace-ups', '/collections/sale-men',
                  '/collections/comfort-eva', 'side=man'];
    for (var i = 0; i < menish.length; i++) if (p.indexOf(menish[i]) > -1) return 'men';
    return 'women';
  }

  function sized(url, w) {
    var base = url.split('?')[0];
    var v = url.indexOf('?v=') > -1 ? '&' + url.split('?')[1] : '';
    return base + '?width=' + w + '&format=webp' + v;
  }

  function buildRow(items, desktop) {
    var row = document.createElement('div');
    row.className = 'amt-row' + (desktop ? ' amt-row--desktop' : '');
    row.setAttribute('role', 'list');
    var w = desktop ? 360 : 240;
    items.forEach(function (it) {
      var a = document.createElement('a');
      a.className = 'amt-tile';
      a.href = it.url;
      a.setAttribute('role', 'listitem');
      var img = document.createElement('img');
      img.src = sized(it.img, w);
      img.srcset = sized(it.img, w) + ' ' + w + 'w, ' + sized(it.img, w * 2) + ' ' + (w * 2) + 'w';
      img.sizes = desktop ? '156px' : '104px';
      img.decoding = 'async';
      img.draggable = false;
      img.alt = it.label;
      if (it.pos) img.style.objectPosition = it.pos;
      var s = document.createElement('span');
      s.textContent = it.label;
      a.appendChild(img);
      a.appendChild(s);
      row.appendChild(a);
    });
    return row;
  }

  function placeMobile() {
    SETS.forEach(function (set) {
      var link = document.querySelector('a.mobile-nav__link[href*="' + set.under + '"]');
      if (!link) return;
      var item = link.closest('li.mobile-nav__item');
      if (!item || !item.parentElement) return;
      if (item.parentElement.querySelector('.amt-li')) return;   // already placed in this list
      var li = document.createElement('li');
      li.className = 'mobile-nav__item amt-li';
      li.setAttribute('data-amt-side', set.side);
      li.appendChild(buildRow(set.items, false));
      if (item.nextSibling) item.parentElement.insertBefore(li, item.nextSibling);
      else item.parentElement.appendChild(li);
    });
  }

  function placeDesktop() {
    var menus = document.querySelectorAll('.site-nav__dropdown.megamenu');
    for (var i = 0; i < menus.length; i++) {
      var mm = menus[i];
      if (mm.querySelector('.amt-row--desktop')) continue;
      var host = mm.querySelector('.page-width') || mm;
      for (var s = 0; s < SETS.length; s++) {
        if (!mm.querySelector('a[href*="' + SETS[s].under + '"]')) continue;
        host.appendChild(buildRow(SETS[s].items, true));
        break;
      }
    }
  }

  function place() { placeMobile(); placeDesktop(); }

  function resetScroll() {
    var rows = document.querySelectorAll('.amt-row');
    for (var i = 0; i < rows.length; i++) rows[i].scrollLeft = 0;
  }

  // every collapsible <li> between the tile row and the top of the menu, outermost first
  function chainFor(li) {
    var chain = [];
    var n = li.parentElement;
    while (n && n !== document.body) {
      if (n.matches && n.matches('li.mobile-nav__item')) {
        var trigger = n.querySelector('.collapsible-trigger');
        if (trigger) chain.push(trigger);
      }
      n = n.parentElement;
    }
    return chain.reverse();
  }

  var opened = false;
  function openSide() {
    if (!AUTO_OPEN || opened) return;
    var li = document.querySelector('.amt-li[data-amt-side="' + side() + '"]');
    if (!li) return;
    opened = true;
    var chain = chainFor(li);
    chain.forEach(function (trigger, i) {
      setTimeout(function () {
        if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
        if (i === chain.length - 1) setTimeout(resetScroll, 450);
      }, i * 280);
    });
  }

  function watchDrawer() {
    var drawer = document.getElementById('NavDrawer');
    if (!drawer) return;
    var check = function () {
      if (!drawer.classList.contains('drawer--is-open')) return;
      setTimeout(openSide, 240);
    };
    check();
    new MutationObserver(check).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function start() {
    place();
    resetScroll();
    watchDrawer();
    // the drawer and megamenu can be re-rendered by the theme, so re-place if they come back empty
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; place(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();